(function () {
    'use strict';

    const module = angular.module('uwAgenda.agenda');
    module.directive('groupedAgendaLabelFilter', ['$rootScope','$filter', 'AgendaFilterBroadcast', GroupedAgendaLabelFilterFn]);

    // filter directive for multiple agenda filter selection
    function GroupedAgendaLabelFilterFn($rootScope, $filter, AgendaFilterBroadcast) {
        const directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/agenda/templates/grouped-agenda-label-filter.template.html',
            scope: {
                agendaLabels: '=',
                paginationService: '='
            }
        };
        return directive;
        function link(scope, element, attrs) {
            // broadcast listener
            let listener = null;
            let listenerCalc = null;
            let listenerClear = null;

            // number of set filter
            scope.numFilters = 0;

            //Caption Intern is only visible for ringphone operators
            scope.getLabel = function (label) {
                if($rootScope.isRingfoon && label.captionIntern){
                    return label.captionIntern;
                } 
                return label.caption;
            }
            

            //activate directive
            activate();
            

            // filter list
            scope.filter = function ($event, label) {
                $event.stopPropagation();
                //reset
                scope.numFilters = 0;

                // role change
                if (label !== null) {
                    label.vmSelected = !label.vmSelected;
                }

                // refresh view
                refresh();
            };

            // destroy
            scope.$on('$destroy', function () {
                // unregister from broadcast
                if (listener) {
                    listener();
                    listener = null;
                }

                if (listenerCalc) {
                    listenerCalc();
                    listenerCalc = null;
                }

                if (listenerClear) {
                    listenerClear();
                    listenerClear = null;
                }
            });

            // calc numbers of appointments with labels
            function calculate() {
                clear();

                // number of appointments in defined types
                for (let j = 0; j < scope.paginationService.data.items.length; j++) {
                    const appointmentsPerDay = scope.paginationService.data.items[j].appointmentsPerDay;
                    // convert object (dictionary with list as value) to array
                    for (const date in appointmentsPerDay) {
                        if (appointmentsPerDay.hasOwnProperty(date)) {
                            const appointmentList = appointmentsPerDay[date];
                            for (let m = 0; m < appointmentList.length; m++) {
                                const state = $filter('filter')(scope.agendaLabels, {'id': appointmentList[m].agendaLabelId}, true)[0];
                                if (state) {
                                    state.vmNumber++;
                                } //if
                            }
                        } //if
                    } // for
                } //for
            } // calculate

            // clear badge counts
            function clear() {
                //reset badge numbers
                for (var i = 0; i < scope.agendaLabels.length; i++) {
                    scope.agendaLabels[i].vmNumber = 0;
                } // for
            }

            // refresh view
            function refresh() {
                // number of selected states
                scope.numFilters = 0;
                for (var i = 0; i < scope.agendaLabels.length; i++) {
                    if (scope.agendaLabels[i].vmSelected) {
                        scope.numFilters++;
                    } //if
                }//for
            } // refresh

            // listen
            function listen() {
                //check for doing a refresh
                listener = scope.$on(AgendaFilterBroadcast.AgendaLabelRefresh, function () {
                    refresh();
                });

                listenerCalc = scope.$on(AgendaFilterBroadcast.AgendaLabelCalculate, function () {
                    calculate();
                });

                listenerClear = scope.$on(AgendaFilterBroadcast.AgendaLabelClear, function () {
                    clear();
                });
            } // listen

            // init work
            function activate() {
                // calculate badge count
                calculate();

                // refresh view
                refresh();

                // listen
                listen();
            } //activate
        } // link
    }
})();